import { getGoalForProgressDisplay, formatGoalProgressPercent } from '../goalProgressUtils';

test('parent and sub-goal progress stay independent of nested child progress', () => {
  const sub = { id: 's1', progress: 0, metric_type: 'percentage', milestones: [{ progress: 100 }] };
  const goal = { id: 'g1', progress: 65, metric_type: 'percentage', sub_goals: [sub] };
  expect(getGoalForProgressDisplay(goal, [sub])).toBe(goal);
  expect(formatGoalProgressPercent(getGoalForProgressDisplay(goal, [sub]))).toBe('65%');
  expect(formatGoalProgressPercent(sub)).toBe('0%');
});

test('zero server progress is not replaced by completed children', () => {
  const goal = { progress: 0, metric_type: 'percentage' };
  expect(formatGoalProgressPercent(getGoalForProgressDisplay(goal, [{ progress: 100 }]))).toBe('0%');
});
